import {EntryShared, socket} from '../shared/scripts/EntryShared'
import {UIUtilsFriends} from '../shared/scripts/ui_friends/UIUtilsFriends'
import {SocketWebActionController} from './scripts/SocketActionController'
import {UIWHeaderController} from './scripts/ui_html/header/UIWHeaderController'
import {UIWGeneralServicesController} from './scripts/UIWGeneralServicesController'
import {UINotificationSendHelper} from '../shared/scripts/notifications/UINotificationSendHelper'

export class EntrySingletonPageShared {
    static initializeSocketAndGeneralServices(headerController: UIWHeaderController | undefined) {
        if(UIUtilsFriends.canUseOnlineFriendService() == false) return
        const generalServicesController = new UIWGeneralServicesController(undefined, headerController)
        const socketActionController = new SocketWebActionController(undefined, undefined, generalServicesController)
        EntryShared.initializeSocket(socketActionController)

        socket.connect()

        generalServicesController.init()

        UINotificationSendHelper.init()
    }
}
